import entrance from "./imgs/D_entrance.jpg";
import entranceDisplay from "./imgs/D_001.jpg";
import exitDisplay from "./imgs/D_002.jpg";
import center from "./imgs/D_003.jpg";
import hayBales from "./imgs/D_004.jpg";
import exit from "./imgs/D_005.jpg";
import corner from "./imgs/D_006.jpg";
import stairs from "./imgs/D_007.jpg";
import upstairsEntrance from "./imgs/D_008.jpg";
import upstairsDisplay from "./imgs/D_009.jpg";
import upstairsCenter from "./imgs/D_010.jpg";
import outsideCenter from "./imgs/D_Home_O.jpg";
import outsideEntrance from "./imgs/D_Home_C.jpg";
import outsideLeft from './imgs/D_Home_L.jpg';
import outsideRight from './imgs/D_Home_R.jpg';
import Urls from "../../constants/urls";

export const homeUrl = Urls.stlBlues.root.path;

const productIds = {
    "antiqueBaseball": '6898929106988',
    "creamAndNavyFittedCap": "6905919602732",
    "fittedCap": "6898928975916",
    "duelingTee": "6898943393836",
    "mitchellNessDuelingTee": "6898943819820",
    "lockupTee": "6898943033388",
    "grayHoodie": "6898942214188",
    "naturalTee":"6898940936236",
    "womensNavyTee": "6898943590444",
    "replicaJersey": "6898932908076",
    "seiyaSuzukiReplicaJersey": "6904376262700",
    "youthJersey": "6898940772396",
    "authenticJersey": "6898932580396",
    "wilsonContrerasReplicaJersey": "6904376098860",
    "MarcusStromanReplicaJersey":"6907060158508"
}


export const shopifyData = {
    domain: "ivyswag.myshopify.com",
    token: "f4be616a519adfe7696b3851c737ed3c",
    productIds: Object.values(productIds),
}


export const entranceHotspots = [
    {
        type: "spot",
        xPosition: 60,
        yPosition: -25,
        zPosition: -60,
        xRotation: -90,
        yRotation: -110,
        zRotation: 200,
        radius: 9,
        link: Urls.ivyShop.entranceDisplay.path
    },
    {
        type: "spot",
        xPosition: 0,
        yPosition: -25,
        zPosition: -110,
        xRotation: -90,
        yRotation: -110,
        zRotation: 200,
        radius: 9,
        link: Urls.ivyShop.center.path
    },
    {
        type: "spot",
        xPosition: -40,
        yPosition: -25,
        zPosition: -110,
        xRotation: -90,
        yRotation: -110,
        zRotation: 200,
        radius: 9,
        link: Urls.ivyShop.hayBales.path
    },
    {
        type:"cart",
        xPosition: 15,
        yPosition: 0,
        zPosition: -7.25,
        yRotation: -30,
        radius: 0.75,
        productId: productIds.MarcusStromanReplicaJersey, //jerseyReplica
    },
    {
        type:"cart",
        xPosition: 20,
        yPosition: 0,
        zPosition: -3.25,
        yRotation: -30,
        radius: 0.75,
        productId: productIds.authenticJersey, //authenticJersey
    },
    {
        type:"cart",
        xPosition: 22,
        yPosition: -1,
        zPosition: -14.25,
        yRotation: -30,
        radius: 0.75,
        productId: productIds.fittedCap, //fittedCap?
    },
    {
        type:"cart",
        xPosition: 18,
        yPosition: -0.25,
        zPosition: -19.25,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.wilsonContrerasReplicaJersey, //wilsonContrerasReplicaJersey?
    },
    {
        type:"cart",
        xPosition: 15,
        yPosition: 0.25,
        zPosition: -25.25,
        yRotation: -70,
        radius: 0.75,
        productId: productIds.seiyaSuzukiReplicaJersey, //seiyaSuzukiReplicaJersey
    },
    {
        type:"cart",
        xPosition: -15,
        yPosition: -1,
        zPosition: -14.25,
        yRotation: 80,
        radius: 0.75,
        productId: productIds.creamAndNavyFittedCap, //creamAndNavyFittedCap
    },
    {
        type:"cart",
        xPosition: -7.5,
        yPosition: -1,
        zPosition: -22,
        yRotation: 30,
        radius: 0.75,
        productId: productIds.antiqueBaseball, //antiqueBaseball
    },
    {
        type:"cart",
        xPosition: 10.25,
        yPosition: 0.25,
        zPosition: -30.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.womensNavyTee, //womensNavyTee
    },
    {
        type:"cart",
        xPosition: 14,
        yPosition: 0.25,
        zPosition: -30.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.lockupTee, //lockupTee
    },
]

export const entranceDisplayHotspots =  [
    {
        type: "spot",
        xPosition: 40,
        yPosition: -25,
        zPosition: 55,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.entrance.path
    },
    {
        type: "spot",
        xPosition: -40,
        yPosition: -25,
        zPosition: 40,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.center.path
    },
    {
        type: "spot",
        xPosition: -20,
        yPosition: -25,
        zPosition: 75,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.hayBales.path
    },
    {
        type: "spot",
        xPosition: -120,
        yPosition: -25,
        zPosition: 0,
        xRotation: -90,
        yRotation: -90,
        zRotation: 300,
        radius: 12,
        link: Urls.ivyShop.exitDisplay.path
    },
    {
        type:"cart",
        xPosition: 0.25,
        yPosition: -3.5,
        zPosition: -15.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.MarcusStromanReplicaJersey, //MarcusStromanReplicaJersey
    },
    {
        type:"cart",
        xPosition: 7.25,
        yPosition: -2.75,
        zPosition: -23.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.authenticJersey, //authenticJersey
    },
    {
        type:"cart",
        xPosition: -7,
        yPosition: -4.5,
        zPosition: -15.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.fittedCap, //fittedCap
    },
    {
        type:"cart",
        xPosition: -23,
        yPosition: -1.5,
        zPosition: -8.25,
        yRotation: 10,
        radius: 0.75,
        productId: productIds.seiyaSuzukiReplicaJersey, //seiyaSuzukiReplicaJersey
    },
    {
        type:"cart",
        xPosition: -14,
        yPosition: -2,
        zPosition: -10.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.wilsonContrerasReplicaJersey, //wilsonContrerasReplicaJersey
    },
    {
        type:"cart",
        xPosition: -5.25,
        yPosition: -2.5,
        zPosition: 22.25,
        yRotation: 180,
        radius: 0.75,
        productId: productIds.creamAndNavyFittedCap, //creamAndNavyFittedCap
    },
    {
        type:"cart",
        xPosition: -12.75,
        yPosition: -2.25,
        zPosition: 16.25,
        yRotation: 150,
        radius: 0.75,
        productId: productIds.antiqueBaseball, //fittedCap
    },
    {
        type:"cart",
        xPosition: -30,
        yPosition: -1,
        zPosition: -4.25,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.womensNavyTee, //womensNavyTee
    },
    {
        type:"cart",
        xPosition: -30,
        yPosition: -1,
        zPosition: -8.75,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.lockupTee, //lockupTee
    },
    {
        type:"cart",
        xPosition: -30,
        yPosition: -1,
        zPosition: 22,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.grayHoodie, //grayHoodie
    },
    {
        type:"cart",
        xPosition: -30,
        yPosition: -1,
        zPosition: 26,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.naturalTee, //yellowTee
    },
]

export const exitDisplayHotspots =  [
    {
        type: "spot",
        xPosition: -70,
        yPosition: -25,
        zPosition: 55,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.exit.path
    },
    {
        type: "spot",
        xPosition: -50,
        yPosition: -25,
        zPosition: 150,
        xRotation: -90,
        yRotation: 180,
        zRotation: 0,
        radius: 12,
        link: Urls.ivyShop.corner.path
    },
    {
        type: "spot",
        xPosition: 40,
        yPosition: -25,
        zPosition: 40,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.center.path
    },
    {
        type: "spot",
        xPosition: 80,
        yPosition: -25,
        zPosition: 70,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.hayBales.path
    },
    {
        type: "spot",
        xPosition: 110,
        yPosition: -25,
        zPosition: -10,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.entranceDisplay.path
    },
    {
        type: "spot",
        xPosition: 140,
        yPosition: -25,
        zPosition: 50,
        xRotation: -90,
        yRotation: 100,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.entrance.path
    },
    {
        type:"cart",
        xPosition: 28.5,
        yPosition: -2,
        zPosition: -10.25,
        yRotation: -10,
        radius: 0.75,
        productId: productIds.MarcusStromanReplicaJersey, //jerseyReplica
    },
    {
        type:"cart",
        xPosition: -14.75,
        yPosition: -1.5,
        zPosition: -19.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.mitchellNessDuelingTee, //whiteTee -> mitchellNessDuelingTee
    },
    {
        type:"cart",
        xPosition: -5,
        yPosition: -1.5,
        zPosition: -19.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.duelingTee, //grayTee -> duelingTee
    },
    {
        type:"cart",
        xPosition: 7,
        yPosition: -2,
        zPosition: -19.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.replicaJersey, //replicaJersey
    },
    {
        type:"cart",
        xPosition: 15,
        yPosition: -2.5,
        zPosition: -11.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.wilsonContrerasReplicaJersey, //wilsonContrerasReplicaJersey
    },
    {
        type:"cart",
        xPosition: 19,
        yPosition: -3,
        zPosition: -11.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.fittedCap, //fittedCap
    },
    {
        type:"cart",
        xPosition: 0,
        yPosition: -2.5,
        zPosition: -12.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.seiyaSuzukiReplicaJersey, //seiyaSuzukiReplicaJersey
    },
    {
        type:"cart",
        xPosition: 14,
        yPosition: -2,
        zPosition: 22.25,
        yRotation: 180,
        radius: 0.75,
        productId: productIds.creamAndNavyFittedCap, //creamAndNavyFittedCap
    },
    {
        type:"cart",
        xPosition: 7.75,
        yPosition: -3.25,
        zPosition: 22.25,
        yRotation: 230,
        radius: 0.75,
        productId: productIds.antiqueBaseball, //fittedCap
    },
    {
        type:"cart",
        xPosition: -20,
        yPosition: -1.25,
        zPosition: -6.5,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.womensNavyTee, //womensNavyTee
    },
    {
        type:"cart",
        xPosition: -20,
        yPosition: -1.25,
        zPosition: -14,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.lockupTee, //lockupTee
    },
    {
        type:"cart",
        xPosition: -14,
        yPosition: -0.75,
        zPosition: 24.5,
        yRotation: 100,
        radius: 0.75,
        productId: productIds.grayHoodie, //grayHoodie
    },
    {
        type:"cart",
        xPosition: -14,
        yPosition: -0.75,
        zPosition: 27.5,
        yRotation: 100,
        radius: 0.75,
        productId: productIds.naturalTee, //yellowTee
    },
]

export const centerHotspots =  [
    {
        type: "spot",
        xPosition: 0,
        yPosition: -25,
        zPosition: 60,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.entrance.path
    },
    {
        type: "spot",
        xPosition: -20,
        yPosition: -15,
        zPosition: 5,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 5,
        link: Urls.ivyShop.hayBales.path
    },
    {
        type: "spot",
        xPosition: 25,
        yPosition: -15,
        zPosition: 20,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 5,
        link: Urls.ivyShop.entranceDisplay.path
    },
    {
        type: "spot",
        xPosition: 25,
        yPosition: -15,
        zPosition: -50,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 5,
        link: Urls.ivyShop.exitDisplay.path
    },
    {
        type:"cart",
        xPosition: 18,
        yPosition: -1.5,
        zPosition: 7,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.MarcusStromanReplicaJersey, //jerseyReplica
    },
    {
        type:"cart",
        xPosition: 25,
        yPosition: -1.5,
        zPosition: 12,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.authenticJersey, //authenticJersey
    },
    {
        type:"cart",
        xPosition: 21,
        yPosition: -2.5,
        zPosition: 2.5,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.fittedCap, //youthJersey?
    },
    {
        type:"cart",
        xPosition: 20,
        yPosition: -1,
        zPosition: -7,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.replicaJersey, //replica
    },
    {
        type:"cart",
        xPosition: 20,
        yPosition: -1.5,
        zPosition: -4,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.wilsonContrerasReplicaJersey, //wilsonContrerasReplicaJersey
    },
    {
        type:"cart",
        xPosition: 20,
        yPosition: -1.5,
        zPosition: -15.25,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.seiyaSuzukiReplicaJersey, //seiyaSuzukiReplicaJersey
    },
    {
        type:"cart",
        xPosition: 20,
        yPosition: -1,
        zPosition: -20.25,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.mitchellNessDuelingTee, //mitchellNessDuelingTee
    },
    {
        type:"cart",
        xPosition: -17,
        yPosition: -3.25,
        zPosition: 2,
        yRotation: 80,
        radius: 0.75,
        productId: productIds.creamAndNavyFittedCap, //creamAndNavyFittedCap
    },
    {
        type:"cart",
        xPosition: -10.5,
        yPosition: -4,
        zPosition: -10,
        yRotation: 45,
        radius: 0.75,
        productId: productIds.antiqueBaseball, //fittedCap
    },
    {
        type:"cart",
        xPosition: 12.75,
        yPosition: -0.75,
        zPosition: -24.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.womensNavyTee, //womensNavyTee
    },
    {
        type:"cart",
        xPosition: 17.5,
        yPosition: -0.75,
        zPosition: -24.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.lockupTee, //lockupTee
    },
    {
        type:"cart",
        xPosition: -13.5,
        yPosition: -0.75,
        zPosition: -24.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.grayHoodie, //grayHoodie
    },
]

export const hayBalesHotspots =  [
    {
        type: "spot",
        xPosition: 40,
        yPosition: -25,
        zPosition: 60,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.center.path
    },
    {
        type: "spot",
        xPosition: -70,
        yPosition: -25,
        zPosition: 70,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.entrance.path
    },
    {
        type: "spot",
        xPosition: -35,
        yPosition: -25,
        zPosition: 110,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.entranceDisplay.path
    },
    {
        type: "spot",
        xPosition: 95,
        yPosition: -25,
        zPosition: 100,
        xRotation: -89,
        yRotation: -90,
        zRotation: 0,
        radius: 12,
        link: Urls.ivyShop.exitDisplay.path
    },
    {
        type:"cart",
        xPosition: -5,
        yPosition: 0,
        zPosition: 25,
        yRotation: 180,
        radius: 0.75,
        productId: productIds.MarcusStromanReplicaJersey, //jerseyReplica
    },
    {
        type:"cart",
        xPosition: -8.5,
        yPosition: 0,
        zPosition: 29,
        yRotation: 180,
        radius: 0.75,
        productId: productIds.authenticJersey, //authenticJersey
    },
    {
        type:"cart",
        xPosition: -0.75,
        yPosition: -0.75,
        zPosition: 25,
        yRotation: 180,
        radius: 0.75,
        productId: productIds.fittedCap, //fittedCap?
    },
    {
        type:"cart",
        xPosition: 14.25,
        yPosition: 0,
        zPosition: 25,
        yRotation: 180,
        radius: 0.75,
        productId: productIds.seiyaSuzukiReplicaJersey, //seiyaSuzukiReplicaJersey
    },
    {
        type:"cart",
        xPosition: 4.75,
        yPosition: 0,
        zPosition: 25,
        yRotation: 180,
        radius: 0.75,
        productId: productIds.wilsonContrerasReplicaJersey, //seiyaSuzukiReplicaJersey
    },
    {
        type:"cart",
        xPosition: 18,
        yPosition: 0.25,
        zPosition: 23,
        yRotation: 180,
        radius: 0.75,
        productId: productIds.mitchellNessDuelingTee, //mitchellNessDuelingTee
    },
    {
        type:"cart",
        xPosition: 7,
        yPosition: 0,
        zPosition: 23,
        yRotation: 180,
        radius: 0.75,
        productId: productIds.replicaJersey, //jerseyReplica
    },
    {
        type:"cart",
        xPosition: -0.5,
        yPosition: -4,
        zPosition: -10,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.creamAndNavyFittedCap, //creamAndNavyFittedCap
    },
    {
        type:"cart",
        xPosition: 13.5,
        yPosition: -2.5,
        zPosition: 3.25,
        yRotation: 300,
        radius: 0.75,
        productId: productIds.antiqueBaseball, //antiqueBaseball
    },
    {
        type:"cart",
        xPosition: 20.75,
        yPosition: 0.25,
        zPosition: 16.25,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.womensNavyTee, //womensNavyTee
    },
    {
        type:"cart",
        xPosition: 20.75,
        yPosition: 0.25,
        zPosition: 20.25,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.lockupTee, //lockupTee
    },
]

export const exitHotspots =  [
    {
        type: "spot",
        xPosition: 30,
        yPosition: -25,
        zPosition: 80,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.exitDisplay.path
    },
    {
        type: "spot",
        xPosition: -110,
        yPosition: -25,
        zPosition: -15,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.corner.path
    },
    {
        type: "arrow",
        xPosition: -85,
        yPosition: -25,
        zPosition: 5,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 8,
        link: Urls.ivyShop.upstairsEntrance.path,
        linkRotation: 83,
    },
    {
        type:"cart",
        xPosition: 14.5,
        yPosition: -1,
        zPosition: 6.25,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.seiyaSuzukiReplicaJersey, //seiyaSuzukiReplicaJersey
    },
    {
        type:"cart",
        xPosition: 14.5,
        yPosition: -1,
        zPosition: 14.75,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.wilsonContrerasReplicaJersey, //wilsonContrerasReplicaJersey
    },
    {
        type:"cart",
        xPosition: 16.5,
        yPosition: -2,
        zPosition: 19.5,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.fittedCap, //fittedCap
    },
    {
        type:"cart",
        xPosition: 22.5,
        yPosition: -1,
        zPosition: 3.5,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.duelingTee, //duelingTee
    },
    {
        type:"cart",
        xPosition: 21.75,
        yPosition: -1.25,
        zPosition: -9,
        yRotation: -10,
        radius: 0.75,
        productId: productIds.lockupTee, //lockupTee
    },
    {
        type:"cart",
        xPosition: 22.5,
        yPosition: -1,
        zPosition: -3,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.mitchellNessDuelingTee, //mitchellNessDuelingTee
    },
    {
        type:"cart",
        xPosition: 22.5,
        yPosition: -1.25,
        zPosition: 12,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.replicaJersey, //replicaJersey
    },
    {
        type:"cart",
        xPosition: 14.5,
        yPosition: -1,
        zPosition: 23.75,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.MarcusStromanReplicaJersey, //replicaJersey
    },
    {
        type:"cart",
        xPosition: -9.5,
        yPosition: -4,
        zPosition: 17,
        yRotation: 180,
        radius: 0.75,
        productId: productIds.antiqueBaseball, //antiqueBaseball
    },
    {
        type:"cart",
        xPosition: -20,
        yPosition: -1,
        zPosition: -8,
        yRotation: 10,
        radius: 0.75,
        productId: productIds.naturalTee, //naturalTee
    },
]

export const cornerHotspots =  [
    {
        type: "spot",
        xPosition: 100,
        yPosition: -25,
        zPosition: -30,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.exit.path
    },
    {
        type: "spot",
        xPosition: 120,
        yPosition: -25,
        zPosition: 40,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.exit.path
    },
    {
        type: "arrow",
        xPosition: 33,
        yPosition: -25,
        zPosition: 27,
        xRotation: -50,
        yRotation: -170,
        zRotation: 90,
        radius: 8,
        link: Urls.ivyShop.upstairsEntrance.path,
        linkRotation: 83,
    },
    {
        type:"cart",
        xPosition: -4.25,
        yPosition: -2.5,
        zPosition: -12.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.naturalTee, //naturalTee
    },
    {
        type:"cart",
        xPosition: 4.5,
        yPosition: -2.75,
        zPosition: -12.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.grayHoodie, //grayHoodie
    },
    {
        type:"cart",
        xPosition: 34.5,
        yPosition: -1.25,
        zPosition: -1.5,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.mitchellNessDuelingTee, //mitchellNessDuelingTee
    },
    {
        type:"cart",
        xPosition: 34.5,
        yPosition: -1.25,
        zPosition: 4,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.duelingTee, //duelingTee
    },
    {
        type:"cart",
        xPosition: 30.5,
        yPosition: -1,
        zPosition: 7,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.seiyaSuzukiReplicaJersey, //seiyaJersey
    },
    {
        type:"cart",
        xPosition: 34.5,
        yPosition: -1.25,
        zPosition: 11.25,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.replicaJersey, //replicaJersey
    },
    {
        type:"cart",
        xPosition: 34.5,
        yPosition: -1.75,
        zPosition: 18,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.wilsonContrerasReplicaJersey, //wilsonContrerasReplicaJersey
    },
    {
        type:"cart",
        xPosition: 34.5,
        yPosition: -2.25,
        zPosition: 21.5,
        yRotation: 270,
        radius: 0.75,
        productId: productIds.fittedCap, //fittedCap
    },
]

export const stairsHotspots =  [
    {
        type: "spot",
        xPosition: 0,
        yPosition: -25,
        zPosition: -150,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 12,
        link: Urls.ivyShop.entrance.path
      }
]

export const upstairsEntranceHotspots =  [
    {
        type: "spot",
        xPosition: -50,
        yPosition: -25,
        zPosition: 50,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.upstairsCenter.path
    },
    {
        type: "spot",
        xPosition: 0,
        yPosition: -25,
        zPosition: 80,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.upstairsDisplay.path
    },
    {
        type: "arrow",
        xPosition: 65,
        yPosition: -25,
        zPosition: -65,
        xRotation: -90,
        yRotation: -90,
        zRotation: 90,
        radius: 8,
        link: Urls.ivyShop.corner.path,
        linkRotation: 83,
    },
    {
        type:"cart",
        xPosition: -4.5,
        yPosition: -1.5,
        zPosition: -16.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.youthJersey, //youthJersey
    },
    {
        type:"cart",
        xPosition: -12.75,
        yPosition: -1.5,
        zPosition: -18.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.replicaJersey, //replicaJersey
    },
    {
        type:"cart",
        xPosition: -1.5,
        yPosition: 1,
        zPosition: -18.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.creamAndNavyFittedCap, //creamAndNavyCap
    },
    {
        type:"cart",
        xPosition: 2.75,
        yPosition: -1.5,
        zPosition: -16.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.seiyaSuzukiReplicaJersey, //seiyaJersey
    },
    {
        type:"cart",
        xPosition: 8.5,
        yPosition: -1.5,
        zPosition: -16.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.MarcusStromanReplicaJersey, //0Jersey
    },
    {
        type:"cart",
        xPosition: 13.5,
        yPosition: 1,
        zPosition: -16.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.fittedCap, //fittedCap
    },
    {
        type:"cart",
        xPosition: 8.5,
        yPosition: -1.5,
        zPosition: 24.25,
        yRotation: -180,
        radius: 0.75,
        productId: productIds.womensNavyTee, //womensTee
    },
    {
        type:"cart",
        xPosition: 1.5,
        yPosition: -1.5,
        zPosition: 24.25,
        yRotation: -180,
        radius: 0.75,
        productId: productIds.lockupTee, //navyTee
    },
    {
        type:"cart",
        xPosition: -4,
        yPosition: -1.5,
        zPosition: 24.25,
        yRotation: -180,
        radius: 0.75,
        productId: productIds.naturalTee, //whiteTee
    },
    {
        type:"cart",
        xPosition: -9.75,
        yPosition: -1.5,
        zPosition: 24.25,
        yRotation: -180,
        radius: 0.75,
        productId: productIds.grayHoodie, //grayHoodie
    },
]

export const upstairsCenterHotspots =  [
    {
        type: "spot",
        xPosition: -40,
        yPosition: -25,
        zPosition: -50,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.upstairsEntrance.path
    },
    {
        type: "spot",
        xPosition: 40,
        yPosition: -25,
        zPosition: -50,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.upstairsDisplay.path
    },
    {
        type: "arrow",
        xPosition: -80,
        yPosition: -25,
        zPosition: -115,
        xRotation: -95,
        yRotation: -90,
        zRotation: 180,
        radius: 8,
        link: Urls.ivyShop.corner.path,
        linkRotation: 83,
    },
    {
        type:"cart",
        xPosition: -20.5,
        yPosition: -1.75,
        zPosition: -9,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.youthJersey, //youthJersey
    },
    {
        type:"cart",
        xPosition: -20.5,
        yPosition: -1.75,
        zPosition: -2.5,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.replicaJersey, //authenticJersey
    },
    {
        type:"cart",
        xPosition: -20.5,
        yPosition: 1,
        zPosition: -12.25,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.creamAndNavyFittedCap, //creamAndNavyCap
    },
    {
        type:"cart",
        xPosition: -20.5,
        yPosition: -1.75,
        zPosition: -16,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.seiyaSuzukiReplicaJersey, //seiyaJersey
    },
    {
        type:"cart",
        xPosition: -20.5,
        yPosition: -1.75,
        zPosition: -21,
        yRotation: 90,
        radius: 0.75,
        productId: productIds.MarcusStromanReplicaJersey, //0Jersey
    },
    {
        type:"cart",
        xPosition: -20.5,
        yPosition: 1,
        zPosition: -26,
        yRotation: 80,
        radius: 0.75,
        productId: productIds.fittedCap, //fittedCap
    },
    {
        type:"cart",
        xPosition: 19.5,
        yPosition: -1.75,
        zPosition: -20.5,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.womensNavyTee, //womensTee
    },
    {
        type:"cart",
        xPosition: 19.5,
        yPosition: -1.75,
        zPosition: -14,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.lockupTee, //navyTee
    },
    {
        type:"cart",
        xPosition: 19.5,
        yPosition: -1.75,
        zPosition: -8.5,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.naturalTee, //whiteTee
    },
    {
        type:"cart",
        xPosition: 19.5,
        yPosition: -1.75,
        zPosition: -2.75,
        yRotation: -90,
        radius: 0.75,
        productId: productIds.grayHoodie, //grayHoodie
    },
]

export const upstairsDisplayHotspots =  [
    {
        type: "spot",
        xPosition: 10,
        yPosition: -25,
        zPosition: 85,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.upstairsEntrance.path
    },
    {
        type: "spot",
        xPosition: 40,
        yPosition: -25,
        zPosition: 55,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.upstairsCenter.path
    },
    {
        type: "arrow",
        xPosition: -55,
        yPosition: -25,
        zPosition: 125,
        xRotation: -90,
        yRotation: -90,
        zRotation: 270,
        radius: 8,
        link: Urls.ivyShop.corner.path,
        linkRotation: 83,
    },
    {
        type:"cart",
        xPosition: 3,
        yPosition: -1.5,
        zPosition: 24.25,
        yRotation: -180,
        radius: 0.75,
        productId: productIds.youthJersey, //youthJersey
    },
    {
        type:"cart",
        xPosition: 8.5,
        yPosition: -1.5,
        zPosition: 24.25,
        yRotation: -180,
        radius: 0.75,
        productId: productIds.replicaJersey, //authenticJersey
    },
    {
        type:"cart",
        xPosition: 0.5,
        yPosition: 0.5,
        zPosition: 24.25,
        yRotation: -180,
        radius: 0.75,
        productId: productIds.creamAndNavyFittedCap, //creamAndNavyCap
    },
    {
        type:"cart",
        xPosition: -3,
        yPosition: -1.5,
        zPosition: 24.25,
        yRotation: -180,
        radius: 0.75,
        productId: productIds.seiyaSuzukiReplicaJersey, //seiyaJersey
    },
    {
        type:"cart",
        xPosition: -7.5,
        yPosition: -1.5,
        zPosition: 24.25,
        yRotation: -180,
        radius: 0.75,
        productId: productIds.MarcusStromanReplicaJersey, //0Jersey
    },
    {
        type:"cart",
        xPosition: -11.5,
        yPosition: 0.5,
        zPosition: 24.25,
        yRotation: -180,
        radius: 0.75,
        productId: productIds.fittedCap, //fittedCap
    },
    {
        type:"cart",
        xPosition: -12,
        yPosition: -2.5,
        zPosition: -15.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.womensNavyTee, //womensTee
    },
    {
        type:"cart",
        xPosition: -3.5,
        yPosition: -2.5,
        zPosition: -15.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.lockupTee, //navyTee
    },
    {
        type:"cart",
        xPosition: 4.25,
        yPosition: -2.5,
        zPosition: -15.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.naturalTee, //whiteTee
    },
    {
        type:"cart",
        xPosition: 11.75,
        yPosition: -2.5,
        zPosition: -15.25,
        yRotation: 0,
        radius: 0.75,
        productId: productIds.grayHoodie, //grayHoodie
    },
]

export const outsideEntranceHotspots = [
    {
        type: "spot",
        xPosition: 0,
        yPosition: -25,
        zPosition: 70,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideCenter.path
    },
    {
        type: "spot",
        xPosition: -90,
        yPosition: -25,
        zPosition: -10,
        xRotation: -95,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideLeft.path
    },
    {
        type: "spot",
        xPosition: 110,
        yPosition: -25,
        zPosition: -10,
        xRotation: -85,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideLeft.path
    },
    {
        type: "arrow",
        xPosition: 4.5,
        yPosition: -25,
        zPosition: -30,
        xRotation: -90,
        yRotation: -90,
        zRotation: 180,
        radius: 8,
        link: Urls.ivyShop.entrance.path,
        linkRotation: 0,
    },
]

export const outsideCenterHotspots = [
    {
        type: "spot",
        xPosition: 0,
        yPosition: -25,
        zPosition: -70,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideEntrance.path
    },
    {
        type: "spot",
        xPosition: -90,
        yPosition: -25,
        zPosition: -90,
        xRotation: -95,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideLeft.path
    },
    {
        type: "spot",
        xPosition: 110,
        yPosition: -25,
        zPosition: -90,
        xRotation: -85,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideRight.path
    },
    {
        type: "arrow",
        xPosition: 4.5,
        yPosition: -25,
        zPosition: -110,
        xRotation: -90,
        yRotation: -90,
        zRotation: 180,
        radius: 8,
        link: Urls.ivyShop.entrance.path,
        linkRotation: 0,
    },
]

export const outsideLeftHotspots = [
    {
        type: "spot",
        xPosition: 100,
        yPosition: -25,
        zPosition: 10,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideEntrance.path
    },
    {
        type: "spot",
        xPosition: 100,
        yPosition: -25,
        zPosition: 60,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideCenter.path
    },
    {
        type: "spot",
        xPosition: 170,
        yPosition: -25,
        zPosition: -10,
        xRotation: -87,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideRight.path
    },
    {
        type: "arrow",
        xPosition: 100,
        yPosition: -25,
        zPosition: -30,
        xRotation: -90,
        yRotation: -90,
        zRotation: 180,
        radius: 8,
        link: Urls.ivyShop.entrance.path,
        linkRotation: 0,
    },
]

export const outsideRightHotspots = [
    {
        type: "spot",
        xPosition: -100,
        yPosition: -25,
        zPosition: 20,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideEntrance.path
    },
    {
        type: "spot",
        xPosition: -100,
        yPosition: -25,
        zPosition: 80,
        xRotation: -90,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideCenter.path
    },
    {
        type: "spot",
        xPosition: -170,
        yPosition: -25,
        zPosition: 0,
        xRotation: -95,
        yRotation: -90,
        zRotation: 0,
        radius: 9,
        link: Urls.ivyShop.outsideLeft.path
    },
    {
        type: "arrow",
        xPosition: -100,
        yPosition: -25,
        zPosition: -20,
        xRotation: -90,
        yRotation: -90,
        zRotation: 180,
        radius: 8,
        link: Urls.ivyShop.entrance.path,
        linkRotation: 0,
    },
]

export const rooms = [
    {
        id: "entrance",
        name: "Entrance",
        img: entrance,
        route: Urls.ivyShop.entrance,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "entrance-display",
        name: "Entrance Display",
        img: entranceDisplay,
        route: Urls.ivyShop.entranceDisplay,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "exit-display",
        name: "Exit Display",
        img: exitDisplay,
        route: Urls.ivyShop.exitDisplay,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "center",
        name: "Center",
        img: center,
        route: Urls.ivyShop.center,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "hay-bales",
        name: "Hay Bales",
        img: hayBales,
        route: Urls.ivyShop.hayBales,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "exit",
        name: "Exit",
        img: exit,
        route: Urls.ivyShop.exit,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "corner",
        name: "Corner",
        img: corner,
        route: Urls.ivyShop.corner,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "stairs",
        name: "Stairs",
        img: stairs,
        route: Urls.ivyShop.stairs,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "upstairs-entrance",
        name: "Upstairs Entrance",
        img: upstairsEntrance,
        route: Urls.ivyShop.entrance,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "upstairs-center",
        name: "Upstairs Center",
        img: upstairsCenter,
        route: Urls.ivyShop.upstairsCenter,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "upstairs-display",
        name: "Upstairs Display",
        img: upstairsDisplay,
        route: Urls.ivyShop.upstairsDisplay,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "outside-left",
        name: "Outside Left",
        img: outsideLeft,
        route: Urls.ivyShop.outsideLeft,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "outside-entrance",
        name: "Outside Entrance",
        img: outsideEntrance,
        route: Urls.ivyShop.outsideEntrance,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "outside-right",
        name: "Outside Right",
        img: outsideRight,
        route: Urls.ivyShop.outsideRight,
        yRotation: 180,
        linkRotation: 180,
    },
    {
        id: "outside-center",
        name: "Outside Center",
        img: outsideCenter,
        route: Urls.ivyShop.outsideCenter,
        yRotation: 180,
        linkRotation: 180,
    }
]